exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-table .warning-row{background:#fdf5e6}", ""]);

// exports
